/**
 * Base64 puro, sin prefijo data URL. No persiste el resultado.
 */
export function stripDataUrlPrefix(value = '') {
  const raw = String(value || '');
  const marker = 'base64,';
  const index = raw.indexOf(marker);
  if (index >= 0) {
    return raw.slice(index + marker.length);
  }
  return raw;
}

export function fileToPureBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(stripDataUrlPrefix(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
